import { useEffect, useState } from 'react';
import styled from 'styled-components';
import client from '../api/client';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import Spinner from '../components/ui/Spinner';
import { Contenedor, TituloPagina, Subtitulo } from '../components/layout/Layout';

const Lista = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.lg};
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Perfil = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.space.sm};

  h2 {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Foto = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.sage};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 2.2rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

function Instructores() {
  const [instructores, setInstructores] = useState(null);

  useEffect(() => {
    client.get('/instructores').then(({ data }) => setInstructores(data)).catch(() => setInstructores([]));
  }, []);

  if (!instructores) return <Spinner />;

  return (
    <Contenedor>
      <TituloPagina>Instructores</TituloPagina>
      <Subtitulo>
        Un equipo certificado que acompaña tu práctica con atención al detalle, desde la primera
        clase hasta el trabajo más avanzado.
      </Subtitulo>
      <Lista>
        {instructores.map((i) => (
          <Perfil key={i.id}>
            <Foto>
              {i.foto_url ? <img src={i.foto_url} alt={`Foto de ${i.nombre}`} /> : <span aria-hidden="true">{i.nombre.charAt(0)}</span>}
            </Foto>
            <h2>{i.nombre}</h2>
            {i.especialidad && <Badge>{i.especialidad}</Badge>}
            {i.certificaciones && <p>{i.certificaciones}</p>}
          </Perfil>
        ))}
      </Lista>
    </Contenedor>
  );
}

export default Instructores;
